var React = require('react');

function Inbox12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 6V10C12 10.5523 11.5523 11 11 11H1C0.447715 11 0 10.5523 0 10V6L1.5 1H10.5L12 6ZM2.08806 6H4.5V6.5C4.5 7.32843 5.17157 8 6 8C6.82843 8 7.5 7.32843 7.5 6.5V6H9.91194L9.01194 3H2.98806L2.08806 6Z","fill":"currentColor"}));
}

Inbox12.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = Inbox12;

Inbox12.default = Inbox12;
